import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import searchFill from '@iconify/icons-eva/search-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import Swal from 'sweetalert2';

// ----------------------------------------------------------------------

export default function CheckOrderMoreMenu({ props, id, status, pPlant, pOrder, pStatus }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* <IconButton ref={ref} component={RouterLink} to={`/dashboard/checkvendor/${id}`}>
        <Icon icon={searchFill} width={20} height={20} />
      </IconButton> */}

      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {(status === 'P' || status === 'V' || status === 'D') && (
          <>
            <MenuItem
              sx={{ color: 'text.secondary' }}
              onClick={() => {
                setIsOpen(false);
                Swal.fire({
                  title: 'Are you sure?',
                  text: "You won't be able to Delete!",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(id);

                    props.deleteOrdersConfirm(id, pPlant, pOrder, pStatus);

                    // Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
                  }
                });
              }}
            >
              <ListItemIcon>
                <Icon icon={trash2Outline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>

            <MenuItem
              sx={{ color: 'text.secondary' }}
              component={RouterLink}
              to={`/dashboard/checkvendor/${id}`}
            >
              <ListItemIcon>
                <Icon icon={editFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
          </>
        )}
        {status === 'S' && (
          <MenuItem
            sx={{ color: 'text.secondary' }}
            component={RouterLink}
            to={`/dashboard/checkvendor/${id}`}
          >
            <ListItemIcon>
              <Icon icon={searchFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="View" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
